<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ data.title }}</h1>
<div mat-dialog-content class="mbp-confirm-dialog__content medicine-dosage-dialog">
  <mat-tab-group>
    <mat-tab label="Create">
      <p class="medicine-dosage-dialog__intro">{{ data.message }}</p>
      <form [formGroup]="dosageTypeForm">
        <p>
          <core-dosage-unit-search-field
            [control]="dosageTypeForm.controls['dosageUnit']"
            (dosageUnitCreated)="onDosageUnitCreated($event)">
          </core-dosage-unit-search-field>
        </p>
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Dosage type</mat-label>
            <input required formControlName="type" type="text" matInput>
            @if (dosageTypeForm.get('type')?.invalid) {
              <mat-error>Dosage type is invalid</mat-error>
            }
          </mat-form-field>
        </p>
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Code</mat-label>
            <input required formControlName="code" type="text" matInput>
            @if (dosageTypeForm.get('code')?.invalid) {
              <mat-error>Code is invalid</mat-error>
            }
          </mat-form-field>
        </p>
      </form>
    </mat-tab>
    <mat-tab label="Manage units">
      <core-dosage-unit-manage-list (dosageUnitsChange)="onDosageUnitsManaged($event)">
      </core-dosage-unit-manage-list>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button type="button" mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  <button type="button" [disabled]="!dosageTypeForm.valid" mat-flat-button color="primary" (click)="createDosageType()">Create</button>
</div>
